'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@common/components';
import { cn } from '@core/utils';
import { Image } from '@/components/client';
export interface CartGroupHeaderProps {
  logoUrl?: string;
  name: string;
  isAllSelected?: boolean;
  onAllSelectChange?: (selected: boolean) => void;
  right?: React.ReactNode;
  className?: string;
}
export const CartGroupHeader = t0 => {
  const $ = _c(18);
  const {
    logoUrl,
    name,
    isAllSelected: t1,
    onAllSelectChange,
    right,
    className
  } = t0;
  const isAllSelected = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex items-center gap-8  rounded-large bg-Gray-white px-24 py-12", "mobile-tablet:rounded-none mobile-tablet:border-b mobile-tablet:border-Gray-200 mobile-tablet:px-20", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isAllSelected || $[3] !== onAllSelectChange) {
    t3 = <Checkbox checked={isAllSelected} onCheckedChange={onAllSelectChange} aria-label={"\uC804\uCCB4 \uC120\uD0DD"} />;
    $[2] = isAllSelected;
    $[3] = onAllSelectChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== logoUrl || $[6] !== name) {
    t4 = <div className="relative size-28 shrink-0 overflow-hidden rounded-pill border border-Gray-300 mobile-tablet:size-24"><Image className="size-full object-cover" src={logoUrl} alt={name} width={28} height={28} /></div>;
    $[5] = logoUrl;
    $[6] = name;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== name) {
    t5 = <p className="font-700 text-Gray-900 typo-body2 mobile-tablet:typo-body4">{name}</p>;
    $[8] = name;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex flex-1 flex-col items-start"><div className="flex items-center gap-8">{t4}{t5}</div></div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== right || $[14] !== t2 || $[15] !== t3 || $[16] !== t6) {
    t7 = <div className={t2}>{t3}{t6}{right}</div>;
    $[13] = right;
    $[14] = t2;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};